module.exports = __webpack_public_path__ + "static/img/jing.4b08756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jing.png
// module id = GzKv
// module chunks = 1